import { Culture, cultureLabels, cultures } from "../../context/VolunteersHighlightContext/constants";

export const GENERAL_SECTION_KEY = "general";

export const getQuestionSectionKey = (culture: Culture) => `question-${culture}`;

export const VolunteersFAQFormKeys = [GENERAL_SECTION_KEY, ...cultures.map(getQuestionSectionKey)];

export const VolunteersFAQSectionLabels = {
	GENERAL: "Genel Bilgiler",
	getQuestion: (culture: Culture) => `Merak Edilenler - ${cultureLabels[culture]}`,
};

export const VolunteersFAQGeneralTexts = {
	isActive: {
		label: "Aktiflik Durumu",
		helperText: "Aktif olmayan sorular sayfada gözükmez.",
	},
	displayOrder: {
		label: "Sıra Numarası",
		placeholder: "1",
	},
};

type QuestionFieldTexts = {
	question: { label: string; placeholder: string };
	answer: { label: string; placeholder: string };
};

export const VolunteersFAQQuestionTexts: Record<Culture, QuestionFieldTexts> = {
	"tr-TR": {
		question: {
			label: "Soru",
			placeholder: "Gönüllü olarak nasıl katılırım?",
		},
		answer: {
			label: "Cevap",
			placeholder: "Gönüllüler bölümümüzü ziyaret edip kayıt formunu doldurabilirsiniz.",
		},
	},
	"en-US": {
		question: {
			label: "Question",
			placeholder: "How do I join as a volunteer?",
		},
		answer: {
			label: "Answer",
			placeholder: "You can visit our volunteers section and fill in the registration form.",
		},
	},
};

// The editor height of the answer, the same as the main text of a volunteers project.
export const ANSWER_EDITOR_HEIGHT = 250;
